import { UIHeader } from "@/provider/data/type";
import useSWR, { Fetcher } from "swr";

const fetcher: Fetcher<UIHeader, string> = (...args) =>
  fetch(...args).then((res) => res.json());

export function useHeader() {
  const { data, error, isLoading } = useSWR("/api/ui-header", fetcher);
  return {
    data,
    error,
    isLoading,
  };
}
